import capsule from "./reducer";
import { key } from "./constants";

export default capsule;
export * from "./actions";
export * from "./sagas";
export * from "./selectors";
export { key };
